import { z } from "zod";

export const spendingSchema = z.object({
  amount: z
    .string()
    .min(1, 'Обовязкове поле'),

  description: z
    .string()
    .min(1, 'Обовязкове поле')
});

export type SpendingSchemaFormScheme = z.infer<typeof spendingSchema>;
